import { BookmarkBoxMultipleIcon } from './BookmarkBoxMultipleIcon';

/**
 * author: Google
 * id 84C06231-55E7-4450-B88D-964B33FCACDA
 * name bookmark-box-multiple
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bookmark-box-multiple.svg
 * tags
 */
export const LibraryBookmarkIcon = BookmarkBoxMultipleIcon;
export default LibraryBookmarkIcon